import React from 'react';
import styles from '../Header.module.css'
import ToolsDropDownToggleButton from './ToolsDropDownToggleButton'
import ToolsDropdown from './ToolsDropdown'
import Trophy from '../trophy.png'

function SiteWelcomeBanner(props){
    function toggleToolsDropdown(){
        const toolsDropdown = document.getElementById('toolsDropdownMenu');
        toolsDropdown.classList.toggle('hidden');
    }
    const name = (props.nickname === "") ?
        "George Weller" :
        "George '"+props.nickname+"' Weller";
    return (
        <div id={styles.siteHeader} className="siteHeader">
            <div id={styles.headerContent} className="horizontallyCentered">
                <img alt="A trophy" src={Trophy} id="headerTrophy" />
                <div id={styles.headerContentLeft}>
                    <h1 id={styles.heading}>{name}</h1>
                    <p id={styles.tagline}>I write things and make websites</p>
                </div>
                <div id={styles.headerContentRight}>
                    <ToolsDropDownToggleButton toggleDropdown={toggleToolsDropdown}></ToolsDropDownToggleButton>
                </div>
                <ToolsDropdown toggleDropdown={toggleToolsDropdown}></ToolsDropdown>
            </div>
        </div>
    );
}

export default SiteWelcomeBanner;